import { Component, OnInit, HostListener } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  show_nav = false;
  isUserMenuOpen = false;
  id = '';
  pageTitle = 'Dashboard';
  pageSubtitle = 'Operations overview';

  constructor(
    private authenticationService: AuthenticationService,
    private toastr: ToastrService,
    private router: Router
  ) { }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (this.isUserMenuOpen && target && !target.closest('.user-menu-wrapper')) {
      this.closeUserMenu();
    }
  }

  ngOnInit(): void {
    const adminJson = localStorage.getItem('admin');
    const userJson = localStorage.getItem('user');
    const currentAdmin = adminJson ? JSON.parse(adminJson) : null;
    const currentUser = userJson ? JSON.parse(userJson) : null;

    if (currentAdmin?.id) {
      this.id = String(currentAdmin.id);
    } else if (currentUser?.id) {
      this.id = String(currentUser.id);
    }
  }

  toggleUserMenu(event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  closeUserMenu(): void {
    this.isUserMenuOpen = false;
  }

  refreshDashboard(): void {
    window.location.reload();
  }

  logout(event?: MouseEvent): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.closeUserMenu();
    const adminJson = localStorage.getItem('admin');
    const userJson = localStorage.getItem('user');
    const currentAdmin = adminJson ? JSON.parse(adminJson) : null;
    const currentUser = userJson ? JSON.parse(userJson) : null;
    const userId = currentUser && currentUser.id ? String(currentUser.id) : '';

    if (currentAdmin) {
      localStorage.removeItem('admin');
      localStorage.removeItem('userRole');
      this.toastr.success('Admin Successfully Logged Out');
      this.router.navigate(['/login']);
    } else {
      this.authenticationService.userLogout(userId).subscribe((res: any) => {
        if (res && res.status === 200) {
          localStorage.removeItem('user');
          localStorage.removeItem('userRole');
          this.toastr.success(res.message);
          this.router.navigate(['/login']);
        } else {
          this.toastr.error(res.message, 'Unable to logout!', { progressBar: true });
        }
      });
    }
  }

  changePassword(event?: MouseEvent): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.closeUserMenu();
    this.router.navigate(['/change-password/', this.id]);
  }

  showNav(event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    this.show_nav = !this.show_nav;
    document.body.classList.toggle('sidebar-open', this.show_nav);
    this.closeUserMenu();
  }
}
